import React from "react";
import axios from "axios";
import { URL, getAuthorizationHeader } from "../../constans/constants";
import { firmaTramite, informacionTramite } from './TramitesService'
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { getUsuarioLogueado, getEmpresa, logout } from "../../components/login/SesionService"
import { createGostCanvasAndGetAppareance, loadSignature } from "../tiposDocumento/AparienciaServicios";


class PinTramite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idLote: "",
      keystore: 0,
      formatoFirmaEmpleado: "",
      pin: "",
      respuesta: "",
      severity: "success",
      mostrarPantallaCarga: false,
      datosUsuarios: {},
      datosEmpresa: {},
      isFirmaEmpleado: false,
      validated: false,
      errorPin: false,
      errors: {},
      mensajeErrorPin: "",
      nombreTramite: "",
      fechaCarga: "",
      supervisores: [],
      isLoaded: false,
    };
    this.dialogRef = React.createRef();
  }

  handleClose = (data) => {
    this.props.handleClose(false, data);
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleFirmasPDF = (tipoFirma, value) => {
    if (tipoFirma == 'EMP')
      this.setState({ isFirmaEmpleado: value })
  };


  handlePinSubmit = async (event) => {
    event.preventDefault();
    if (this.state.mostrarPantallaCarga) return;
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      this.setState({ validated: true })
    } else {
      if (this.state.keystore == 0) {
        this.setState({
          errorPin: true,
          mensajeErrorPin: "*Ocurrio un error mientras se recuperaban datos del keystore"
        })
      } else {
        this.setState({ mostrarPantallaCarga: true });
        try {
          let formatoEmpleado = await loadSignature(this.state.formatoFirmaEmpleado, this.state.datosUsuarios, this.state.datosEmpresa, false);
          let json = {
            appearance: null,
            keystoreId: this.state.keystore,
            pin: this.state.pin,
            idTramite: this.props.idTramite
          };
          if (formatoEmpleado.appearance) {
            json = await createGostCanvasAndGetAppareance(formatoEmpleado, json, this.props.estado, this.handleClose, this.handleFirmasPDF);
            await this.firmar(json)
          } else {
            this.setState({ mostrarPantallaCarga: false });
          }
        } catch (error) {
          this.setState({
            mostrarPantallaCarga: false,
            errorPin: true,
            mensajeErrorPin: "*Ocurrio un error al firmar el trámite"
          });
        }
      }
    }

  };

  firmar = async (json) => {
    const response = await firmaTramite(json);
    this.setState({ mostrarPantallaCarga: false });
    this.handleClose(response);
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.cargarDatosIniciales()
    }
  }

  cargarDatosIniciales = () => {
    const aparienciaFirma = localStorage.getItem("aparienciaFirmaTramite");

    let token = {
      token: localStorage.getItem("tokenIscert"),
      psa: localStorage.getItem("codigoClienteFirma")
    }
    axios
      .post(URL + "payrolls/iscert/keystore", token, getAuthorizationHeader())
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ keystore: res.data.datos.keystores[0].id,  isLoaded: true});
        } else {
          this.setState({ isLoaded: false });
          this.manejarCancelar(); // Cerramos el modal con animación
          this.props.handleClose(false, res.data);
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      })

    informacionTramite(this.props.idTramite).then((resp) => {
      if (!resp.error) {
        this.setState({
          nombreTramite: resp.datos.nombre,
          supervisores: resp.datos.supervisores,
          fechaCarga: resp.datos.dateCreated,
        });
      } else {
         this.props.handleClose(false, resp.mensaje);
      }
    });

    if (aparienciaFirma == null) {
       this.props.handleClose(false, "Debe cargar una apariencia de firma antes de continuar");
      //this.setState({ errorPin: true, mensajeErrorPin: "*Debe cargar una apariencia de firma antes de continuar" })
    } else {
      this.setState({ formatoFirmaEmpleado: aparienciaFirma });
      getUsuarioLogueado().then((response) => {
        this.setState({ datosUsuarios: response });
      });
      getEmpresa().then((response) => {
        this.setState({ datosEmpresa: response })
      });
    }
  }

  handleInput = (e) => {
    const name = e.target.name;
    const val = e.target.value;
    if (this.state.errorPin)
      this.setState({
        [name]: val,
        errorPin: false,
        mensajeErrorPin: ""
      });
    else
      this.setState({
        [name]: val,
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.cargarDatosIniciales();
    }

    if (!prevState.isLoaded && this.state.isLoaded) {
      this.abrirModal();
    }

    if (!this.props.isOpen && prevProps.isOpen) {
      this.cerrarModalConAnimacion();
    }
  }
  

  abrirModal = () => {
    if (this.dialogRef.current && !this.dialogRef.current.open) {
      this.dialogRef.current.showModal();
    }
  }

  cerrarModal = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.close();
    }
  }

  cerrarModalConAnimacion = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.style.scale = '0';
      setTimeout(() => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
          this.dialogRef.current.close();
        }
      }, 300);
    }
  }

  manejarCancelar = () => {
    this.cerrarModalConAnimacion();
    setTimeout(() => {
      this.props.handleClose(false, null);
    }, 300);
  }

  handleClickCancelar = () => {
    this.manejarCancelar();
  }

  render() {
    const { isOpen } = this.props;

    if (!isOpen || !this.state.isLoaded) return null;

    return (
      <div className="component-modal">
        <dialog
          className="modal"
          id="modal-pin"
          ref={this.dialogRef}
          onClose={this.handleClose}
        >
          <PantallaCarga open={this.state.mostrarPantallaCarga} mensaje="Firmando..." />
          <div className="modal-content">
            <div className="modal-body">
              <h3 className="title">{this.props.dialogTitle || 'Ingresar PIN de firma'}</h3>

              {/* Datos del lote (ahora visibles si es necesario) */}
              <div className="datosLotes">
                <p className="form-date"><strong>Confirmar datos:</strong></p>
                <div className="lote-date">
                  <p className="lote-text"><strong>fecha:</strong> {this.props.fechaCarga}</p>
                </div>
                <div className="lote-row">
                  <p className="lote-text"><strong>Concepto: </strong>{this.props.nombre}</p>
                </div>
              </div>

              <p className="form-date">
                <strong>Ingresa el Pin de Firma para firmar el recibo seleccionado:</strong>
              </p>

              {/* Formulario de PIN */}
              <form className="form" noValidate onSubmit={this.handlePinSubmit}>
<div className="form-group" style={{ position: 'relative' }}>
  <input
    id="pin"
    type={this.state.mostrarPassword ? "text" : "password"}
    name="pin"
    className="form-input"
    placeholder=""
    onChange={this.handleInput}
    value={this.state.pin}
    required
  />
  <label htmlFor="pin" className="form-label">Ingresar tu PIN</label>
  <button
    type="button"
    onClick={this.setMostrarPassword}
    className="btn-eye"
    style={{
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      cursor: 'pointer'
    }}
  >
<span className="material-symbols-outlined"> visibility </span>
  </button>
</div>

                {/* Errores */}
                {this.state.errors.pin && (
                  <div className="error-message">
                    <small style={{ color: "red" }}>{this.state.errors.pin}</small>
                  </div>
                )}

                {this.state.errorPin && (
                  <div className="error-message">
                    <small style={{ color: "red" }}>
                      *Ocurrió un error mientras se recuperaban datos del keystore
                    </small>
                  </div>
                )}

                {/* Footer del modal */}
                <div className="modal-footer">
                  <button
                    className="btn-medium btn-base-outline"
                    type="button"
                    onClick={() => this.handleClose(null)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn-medium btn-primary"
                    type="submit"
                    disabled={this.state.mostrarPantallaCarga}
                  >
                    {this.state.mostrarPantallaCarga ? "Firmando..." : "Firmar"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </dialog>
      </div>
    );
    //}

  }

}

export default PinTramite;
